import { useMutation } from "@tanstack/react-query";
import axiosInstance from "../../../api";
import { useOktaAuth } from "@okta/okta-react";
import { AxiosError } from "axios";

interface GetMultipleOrdersPDFParams {
  orderIds: string[];
  onStart?: () => void;
  onSuccess?: () => void;
  onError?: (error: string) => void;
}

function useGetMultipleOrdersPDF() {
  const { authState } = useOktaAuth();

  return useMutation({
    mutationKey: ["getMultipleOrdersPDF"],
    mutationFn: ({ orderIds, onStart, onSuccess, onError }: GetMultipleOrdersPDFParams) => {
      onStart?.();
      const idsParam = orderIds.join(',');
      
      return axiosInstance.get(
        `v1/orders/multiple-orders?orderIds=${idsParam}`,
        {
          headers: {
            Authorization: `Bearer ${authState?.accessToken?.accessToken}`,
          },
        }
      );
    },
    onSuccess: (response, variables) => {
      variables.onSuccess?.();
      return response;
    },
    onError: (error: AxiosError<any, any>, variables) => {
      const errorMessage = error?.message ?? "Failed printing order";
      variables.onError?.(errorMessage);
    },
  });
}

export default useGetMultipleOrdersPDF;
